import { Card, Input, Typography } from '@fe-toolkit/web-components/ssr'

import { EVisitType, RequestCallCheckbox } from '@giffgaff/broadband-common'

export type InstallContactInfoCardProps = {
  variant?: EVisitType.IN_HOME | EVisitType.PRE_WORK
  firstName: string
  lastName: string
  phoneNumber: string
  requestedCall: boolean
  handleFirstNameChange: (value: string) => void
  handleLastNameChange: (value: string) => void
  handlePhoneNumberChange: (value: string) => void
  handleRequestedCallChange: (value: boolean) => void
}

const allowedTelKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End']

const allowedTextKeys = [...allowedTelKeys, 'Tab']

export const InstallContactInfoCard = ({
  variant,
  firstName,
  lastName,
  phoneNumber,
  requestedCall,
  handleFirstNameChange,
  handleLastNameChange,
  handlePhoneNumberChange,
  handleRequestedCallChange,
}: InstallContactInfoCardProps) => {
  const title = variant === EVisitType.IN_HOME ? 'Home install contact info' : 'Outside install contact info'

  const updateFirstName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.slice(0, 40)

    handleFirstNameChange(val)
  }

  const updateLastName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.slice(0, 40)

    handleLastNameChange(val)
  }

  const updatePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    handlePhoneNumberChange(e.target.value)
  }

  const handleTelKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (allowedTelKeys.includes(e.key)) return

    if (e.metaKey || e.ctrlKey) return

    if (/^[0-9()+\s]$/.test(e.key)) return

    e.preventDefault()
  }

  const handleTextKeydown = (e: React.KeyboardEvent<HTMLInputElement>, name: string) => {
    if (allowedTextKeys.includes(e.key)) return

    if (e.metaKey || e.ctrlKey) return

    if (name.length >= 40) {
      e.preventDefault()

      return
    }

    if (/^[a-zA-Z\s'-]$/.test(e.key)) return

    e.preventDefault()
  }

  return (
    <Card
      borderColor="gallery"
      borderWidth={2}
      sx={({ theme }) => ({ flexDirection: 'column', padding: theme.spacing.small })}
    >
      <Typography as="h2" sx={({ theme }) => ({ margin: `0 0 ${theme.spacing.medium}` })} variant="shout">
        {title}
      </Typography>
      <Input
        data-di-mask
        label="First name"
        pattern="^[a-zA-Z\s'-]{1,40}$"
        value={firstName}
        onChange={updateFirstName}
        onKeyDown={event => handleTextKeydown(event, firstName)}
      />
      <Input
        data-di-mask
        label="Last name"
        pattern="^[a-zA-Z\s'-]{1,40}$"
        value={lastName}
        onChange={updateLastName}
        onKeyDown={event => handleTextKeydown(event, lastName)}
      />
      <Input
        data-di-mask
        label="Phone number"
        pattern="^(\(?(0|\+44|0044|44)[1-9]\d{1,4}?\)?\s?\d{3,4}\s?\d{3,4})$"
        type="tel"
        value={phoneNumber}
        onChange={updatePhoneNumber}
        onKeyDown={handleTelKeyDown}
      />
      <Typography as="p" variant="murmur">
        In case the engineer needs to call on the install day.
      </Typography>
      <RequestCallCheckbox checked={requestedCall} onChange={() => handleRequestedCallChange(!requestedCall)} />
    </Card>
  )
}

export default InstallContactInfoCard
